const showResult = document.querySelectorAll(".t4s-show-result"),
    quizLoader = document.querySelector(".terminal-loader"),
    quizProducts = document.querySelector("#quiz-products"),
    quizContainer = document.querySelector(".quiz-container");
let btnValue = "",
    items = [],
    productHandles = [],
    male = !1,
    female = !1,
    prefer = !1,
    burnsAndTurns = !1,
    tansGradually = !1,
    notTans = !1,
    unSure = !1,
    acne = !1,
    dryness = !1,
    oilAndShine = !1,
    pigmentation = !1,
    enlargedPores = !1,
    fineLines = !1,
    sensitivity = !1,
    unevenSkin = !1,
    fullBodyWhitening = !1,
    fullBodyCare = !1,
    antiAging = !1,
    glowingSkin = !1,
    darkSpots = !1,
    dullness = !1,
    Straight = !1,
    Normal = !1,
    Wavy = !1,
    Coily = !1,
    hairDryness = !1,
    Frizz = !1,
    Breakage = !1,
    Dandruff = !1,
    CThinning = !1,
    Irritation = !1,
    cellularHealth = !1,
    weightLoss = !1,
    heart = !1,
    nailsGrowth = !1,
    menVitality = !1,
    acneFree = !1,
    womenHealth = !1,
    birthDefects = !1,
    boneHealth = !1,
    booster = !1,
    disorder = !1;
function enableBtn(n) {
    n
        .closest("section")
        .querySelectorAll(".t4s-option-btn")
        .forEach((n) => n.classList.remove("active_btn")),
        n.classList.add("active_btn"),
        n.parentElement.lastElementChild.firstElementChild && (n.parentElement.lastElementChild.firstElementChild.disabled = !1);
}
function handleButtonClick(n) {
    const e = n.target;
    let t = e.closest("section");
    "skincare" == e.value
        ? ((t.nextElementSibling.style.display = "block"), (btnValue = e.value), enableBtn(e))
        : "haircare" == e.value
        ? ((t.nextElementSibling.nextElementSibling.style.display = "block"), (btnValue = e.value), enableBtn(e))
        : "healthcare" == e.value
        ? ((t.nextElementSibling.nextElementSibling.nextElementSibling.style.display = "block"), (btnValue = e.value), enableBtn(e))
        : e.classList.contains("t4s-next-btn")
        ? "skincare" == btnValue
            ? ((t.nextElementSibling.firstElementChild.style.display = "block"), (t.style.display = "none"), (btnValue = ""))
            : "haircare" == btnValue
            ? ((t.nextElementSibling.nextElementSibling.firstElementChild.style.display = "block"), (t.style.display = "none"), (btnValue = ""))
            : "healthcare" == btnValue
            ? ((t.nextElementSibling.nextElementSibling.nextElementSibling.firstElementChild.style.display = "block"), (t.style.display = "none"), (btnValue = ""))
            : ((t.nextElementSibling.style.display = "block"), (t.style.display = "none"))
        : "male" == e.value
        ? ((male = !0), (female = !1), (prefer = !1), enableBtn(e))
        : "female" == e.value
        ? ((female = !0), (male = !1), (prefer = !1), enableBtn(e))
        : "notspecific" == e.value
        ? ((prefer = !0), (male = !1), (female = !1), enableBtn(e))
        : "burnsandturnsred" == e.value
        ? ((burnsAndTurns = !0), (tansGradually = !1), (notTans = !1), (unSure = !1), enableBtn(e), productHandles.push("bioxcin-suncare-spray-spf-50-200ml", "bioxcin-suncare-cream-spf-50"))
        : "tansgradually" == e.value
        ? ((tansGradually = !0), (burnsAndTurns = !1), (notTans = !1), (unSure = !1), enableBtn(e), productHandles.push("gluvit-s-sunscreen-spf-60", "bioxcin-suncare-spray-spf-50-200ml", "radiant-ultra-sunblock"))
        : "doesnttan" == e.value
        ? ((notTans = !0), (tansGradually = !1), (burnsAndTurns = !1), (unSure = !1), enableBtn(e), productHandles.push("bioxcin-suncare-spray-spf-50-200ml"))
        : "imunsure" == e.value
        ? ((unSure = !0), (notTans = !1), (tansGradually = !1), (burnsAndTurns = !1), enableBtn(e), productHandles.push("gluvit-s-sunscreen-spf-60"))
        : "acnebreakouts" == e.value
        ? ((acne = !0),
          (dryness = !1),
          (oilAndShine = !1),
          (pigmentation = !1),
          (enlargedPores = !1),
          (fineLines = !1),
          (sensitivity = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-anti-acne-serum", "la-skin-mandelic-solution", "healthmax-ab-claro"))
        : "drynessdehydration" == e.value
        ? ((dryness = !0),
          (acne = !1),
          (oilAndShine = !1),
          (pigmentation = !1),
          (enlargedPores = !1),
          (fineLines = !1),
          (sensitivity = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-face-body-whitening-lotion", "bioxsine-pure-white-whitening-body-lotion"))
        : "excessoilshine" == e.value
        ? ((oilAndShine = !0),
          (dryness = !1),
          (acne = !1),
          (pigmentation = !1),
          (enlargedPores = !1),
          (fineLines = !1),
          (sensitivity = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("la-skin-face-wash", "gluvit-s-sunscreen-spf-60", "radiant-ultra-sunblock"))
        : "darkspotspigment" == e.value
        ? ((pigmentation = !0),
          (dryness = !1),
          (acne = !1),
          (oilAndShine = !1),
          (enlargedPores = !1),
          (fineLines = !1),
          (sensitivity = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-brightening-serum", "bioxcin-hyaluronic-acid-serum", "cosmed-intensive-lightening-cream"))
        : "enlargedpores" == e.value
        ? ((enlargedPores = !0),
          (dryness = !1),
          (acne = !1),
          (oilAndShine = !1),
          (pigmentation = !1),
          (fineLines = !1),
          (sensitivity = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-pore-tightening-lightening-serum", "gluvit-s-collagen-powder", "gluvit-s-sunscreen-spf-60"))
        : "finelineswrinkle" == e.value
        ? ((fineLines = !0),
          (dryness = !1),
          (acne = !1),
          (oilAndShine = !1),
          (pigmentation = !1),
          (enlargedPores = !1),
          (sensitivity = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-oral-liquid-glutathione", "gluvit-s-sunscreen-spf-60", "bioxcin-hyaluronic-acid-serum"))
        : "sensitivityredne" == e.value
        ? ((sensitivity = !0),
          (dryness = !1),
          (acne = !1),
          (oilAndShine = !1),
          (pigmentation = !1),
          (enlargedPores = !1),
          (fineLines = !1),
          (unevenSkin = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-sunscreen-spf-60", "glow-max-whitening", "bioxcin-suncare-cream-spf-50"))
        : "unevenskintonete" == e.value
        ? ((unevenSkin = !0),
          (dryness = !1),
          (acne = !1),
          (oilAndShine = !1),
          (pigmentation = !1),
          (enlargedPores = !1),
          (fineLines = !1),
          (sensitivity = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-skin-brightening-cream", "radiant-ultra-sunblock", "gluvit-s-30-capsules"))
        : "achievefullbodyw" == e.value
        ? ((fullBodyWhitening = !0),
          (fullBodyCare = !1),
          (antiAging = !1),
          (glowingSkin = !1),
          (darkSpots = !1),
          (dullness = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-oral-liquid-glutathione", "gluvit-s-collagen-powder", "gluvit-s-brightening-serum", "gluvit-s-sunscreen-spf-60", "deep-white", "gluvit-s-face-body-whitening-lotion"))
        : "maintainfullbody" == e.value
        ? ((fullBodyCare = !0),
          (fullBodyWhitening = !1),
          (antiAging = !1),
          (glowingSkin = !1),
          (darkSpots = !1),
          (dullness = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-face-body-whitening-lotion", "gluvit-s-eye-contour-serum", "la-skin-fantom-lip-serum", "gluvit-s-sunscreen-spf-60", "gluvit-s-collagen-powder", "radiant-skin"))
        : "focusonantiaging" == e.value
        ? ((antiAging = !0),
          (fullBodyWhitening = !1),
          (fullBodyCare = !1),
          (glowingSkin = !1),
          (darkSpots = !1),
          (dullness = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-collagen-powder", "gluvit-s-advance-anti-aging-serum", "gluvit-s-sunscreen-spf-60", "bioxcin-hyaluronic-acid-serum"))
        : "attainyounger&gl" == e.value
        ? ((glowingSkin = !0),
          (fullBodyWhitening = !1),
          (fullBodyCare = !1),
          (antiAging = !1),
          (darkSpots = !1),
          (dullness = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-oral-liquid-glutathione", "gluvit-s-anti-acne-serum", "gluvit-s-collagen-powder", "gluvit-s-advance-anti-aging-serum", "gluvit-s-sunscreen-spf-60", "gluvit-s-collagen-febgen-liquid"))
        : "addresswrinklesd" == e.value
        ? ((darkSpots = !0),
          (fullBodyWhitening = !1),
          (fullBodyCare = !1),
          (antiAging = !1),
          (glowingSkin = !1),
          (dullness = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-oral-liquid-glutathione", "gluvit-s-sunscreen-spf-60", "gluvit-s-face-body-whitening-lotion", "bioxcin-hyaluronic-acid-serum", "biota-anti-wrinkle-serum"))
        : "improvedullness" == e.value
        ? ((dullness = !0),
          (fullBodyWhitening = !1),
          (fullBodyCare = !1),
          (antiAging = !1),
          (glowingSkin = !1),
          (darkSpots = !1),
          enableBtn(e),
          productHandles.push("gluvit-s-collagen-powder", "gluvit-s-face-body-whitening-lotion", "gluvit-s-brightening-vitamin-c-serum", "gluvit-s-sunscreen-spf-60"))
        : "straight" == e.value
        ? ((Straight = !0), enableBtn(e), productHandles.push("bioxsine-dermagen-fort-shampoo-100ml", "bioxsine-fort-shampoo-300ml", "bioxcin-dermagen-forte-shampoo-100ml-3-in-1"))
        : "normal" == e.value
        ? ((Normal = !0), enableBtn(e), productHandles.push("bioxcin-keratin-argan-oil", "nutraxin-biotin-5000mcg"))
        : "wavy" == e.value || "curly" == e.value
        ? ((Wavy = !0),
          enableBtn(e),
          productHandles.push(
              "bioxcin-keratin-argan-oil",
              "bioxsine-fort-herbal-spray-50-ml",
              "bioxsine-dermagen-intensive-hair-serum-150ml",
              "bioxsine-dermagen-fort-shampoo-100ml",
              "bioxsine-fort-shampoo-300ml",
              "bioxcin-dermagen-forte-shampoo-100ml-3-in-1"
          ))
        : "coilykinky" == e.value
        ? ((Coily = !0), enableBtn(e), productHandles.push("bioxcin-keratin-argan-oil", "bioxsine-dermagen-fort-shampoo-100ml", "bioxsine-fort-shampoo-300ml", "bioxcin-dermagen-forte-shampoo-100ml-3-in-1"))
        : "dryness" == e.value
        ? ((hairDryness = !0),
          enableBtn(e),
          productHandles.push("bioxsine-fort-herbal-spray-50-ml", "bioxsine-dermagen-fort-shampoo-100ml", "bioxsine-fort-shampoo-300ml", "bioxcin-dermagen-forte-shampoo-100ml-3-in-1", "nutraxin-biotin-5000mcg"))
        : "frizz" == e.value
        ? ((Frizz = !0), enableBtn(e), productHandles.push("bioxcin-keratin-argan-oil", "bioxsine-dermagen-fort-shampoo-100ml", "bioxsine-fort-shampoo-300ml", "bioxcin-dermagen-forte-shampoo-100ml-3-in-1", "nutraxin-biotin-5000mcg"))
        : "damagebreakage" == e.value
        ? ((Breakage = !0),
          enableBtn(e),
          productHandles.push(
              "bioxcin-hair-loss-fighter-bundle",
              "bioxcin-keratin-argan-oil",
              "bioxsine-fort-herbal-spray-50-ml",
              "bioxsine-dermagen-intensive-hair-serum-150ml",
              "bioxsine-dermagen-fort-shampoo-100ml",
              "bioxsine-fort-shampoo-300ml",
              "bioxcin-dermagen-forte-shampoo-100ml-3-in-1"
          ))
        : "dandruffflakysca" == e.value
        ? ((Dandruff = !0), enableBtn(e), productHandles.push("bioxsine-fort-herbal-spray-50-ml", "bioxsine-dermagen-intensive-hair-serum-150ml", "nutraxin-biotin-5000mcg"))
        : "thinninghairloss" == e.value
        ? ((CThinning = !0),
          enableBtn(e),
          productHandles.push("gluvit-s-collagen-powder", "bioxsine-fort-herbal-spray-50-ml", "bioxsine-dermagen-fort-shampoo-100ml", "bioxsine-fort-shampoo-300ml", "bioxcin-dermagen-forte-shampoo-100ml-3-in-1", "nutraxin-biotin-5000mcg"))
        : "scalpsensitivity" == e.value &&
          ((Irritation = !0), enableBtn(e), productHandles.push("bioxcin-keratin-argan-oil", "bioxsine-dermagen-fort-shampoo-100ml", "bioxsine-fort-shampoo-300ml", "bioxcin-dermagen-forte-shampoo-100ml-3-in-1")),
        "supportingcellul" == e.value
            ? ((cellularHealth = !0), enableBtn(e))
            : "boostingenergyan" == e.value
            ? ((weightLoss = !0), enableBtn(e), productHandles.push("gluvit-s-collagen-powder", "health-max-vito-burn", "nutraxin-magnesium-complex-vitamin-b6", "nutraxin-zinc-for-immunity-and-support", "nutraxin-zero-balance-tablets"))
            : "supportingheartb," == e.value
            ? ((heart = !0), enableBtn(e), productHandles.push("nutraxin-omega-3-coq-10-with-coenzyme", "nutraxin-magnesium-complex-vitamin-b6", "nutraxin-magnesium-citrate-250mg", "coenzyme-q-10"))
            : "enhancinghairski" == e.value
            ? ((nailsGrowth = !0), enableBtn(e), productHandles.push("gluvit-s-collagen-powder", "gluvit-s-collagen-febgen-liquid", "nutraxin-biotin-5000mcg", "nutraxin-zinc-for-immunity-and-support"))
            : "improvingvitali" == e.value
            ? ((menVitality = !0), enableBtn(e))
            : "maintainingclear" == e.value
            ? ((acneFree = !0), enableBtn(e), productHandles.push("gluvit-s-collagen-powder", "healthmax-ab-claro", "nutraxin-zinc-for-immunity-and-support"))
            : "supportingwomens" == e.value
            ? ((womenHealth = !0), enableBtn(e), productHandles.push("nutraxin-women-multivitamin-complex", "health-max-rascor", "nutraxine-oxi-formula"))
            : "preventingbirthd" == e.value
            ? ((birthDefects = !0), enableBtn(e), productHandles.push("health-max-rascor"))
            : "supportingbonehe" == e.value
            ? ((boneHealth = !0), enableBtn(e), productHandles.push("nutraxin-artroflex-hva-c-il-tab-90s", "nutraxin-vitamin-d3-1000-iu-tab-120s", "nutraxin-artroflex-hva-c-il-tab-90s", "nutraxin-vitamin-d3-1000-iu-tab-120s"))
            : "immunitybooster" == e.value
            ? ((booster = !0), enableBtn(e), productHandles.push("gluvit-s-collagen-powder", "health-max-glo-e", "nutraxin-zinc-for-immunity-and-support"))
            : "sleepingdisorder" == e.value
            ? ((disorder = !0), enableBtn(e), productHandles.push("nutraxin-magnesium-complex-vitamin-b6", "nutraxin-b-one-formula-90tab"))
            : (e.parentElement.querySelectorAll("button[type=button]").forEach((n) => n.classList.remove("active_btn")), enableBtn(e));
}
const buttons = document.querySelectorAll(".t4s-image-text-quiz button:not(.t4s-show-result)");
buttons.forEach(function (n) {
    n.addEventListener("click", (n) => {
        handleButtonClick(n);
    });
}),
    showResult.forEach((n) => {
        n.addEventListener("click", function () {
            ((burnsAndTurns && acne && fullBodyWhitening) ||
                (tansGradually && acne && fullBodyWhitening) ||
                (notTans && acne && fullBodyWhitening) ||
                (unSure && acne && fullBodyWhitening) ||
                (burnsAndTurns && dryness && fullBodyWhitening) ||
                (tansGradually && dryness && fullBodyWhitening) ||
                (notTans && dryness && fullBodyWhitening) ||
                (unSure && dryness && fullBodyWhitening) ||
                (burnsAndTurns && oilAndShine && fullBodyWhitening) ||
                (tansGradually && oilAndShine && fullBodyWhitening) ||
                (notTans && oilAndShine && fullBodyWhitening) ||
                (unSure && oilAndShine && fullBodyWhitening) ||
                (burnsAndTurns && pigmentation && fullBodyWhitening) ||
                (tansGradually && pigmentation && fullBodyWhitening) ||
                (notTans && pigmentation && fullBodyWhitening) ||
                (unSure && pigmentation && fullBodyWhitening) ||
                (burnsAndTurns && enlargedPores && fullBodyWhitening) ||
                (tansGradually && enlargedPores && fullBodyWhitening) ||
                (notTans && enlargedPores && fullBodyWhitening) ||
                (unSure && enlargedPores && fullBodyWhitening) ||
                (burnsAndTurns && fineLines && fullBodyWhitening) ||
                (tansGradually && fineLines && fullBodyWhitening) ||
                (notTans && fineLines && fullBodyWhitening) ||
                (unSure && fineLines && fullBodyWhitening) ||
                (burnsAndTurns && sensitivity && fullBodyWhitening) ||
                (tansGradually && sensitivity && fullBodyWhitening) ||
                (notTans && sensitivity && fullBodyWhitening) ||
                (unSure && sensitivity && fullBodyWhitening) ||
                (burnsAndTurns && unevenSkin && fullBodyWhitening) ||
                (tansGradually && unevenSkin && fullBodyWhitening) ||
                (notTans && unevenSkin && fullBodyWhitening) ||
                (unSure && unevenSkin && fullBodyWhitening)) &&
                showResults(productHandles),
                ((burnsAndTurns && acne && fullBodyCare) ||
                    (tansGradually && acne && fullBodyCare) ||
                    (notTans && acne && fullBodyCare) ||
                    (unSure && acne && fullBodyCare) ||
                    (burnsAndTurns && dryness && fullBodyCare) ||
                    (tansGradually && dryness && fullBodyCare) ||
                    (notTans && dryness && fullBodyCare) ||
                    (unSure && dryness && fullBodyCare) ||
                    (burnsAndTurns && oilAndShine && fullBodyCare) ||
                    (tansGradually && oilAndShine && fullBodyCare) ||
                    (notTans && oilAndShine && fullBodyCare) ||
                    (unSure && oilAndShine && fullBodyCare) ||
                    (burnsAndTurns && pigmentation && fullBodyCare) ||
                    (tansGradually && pigmentation && fullBodyCare) ||
                    (notTans && pigmentation && fullBodyCare) ||
                    (unSure && pigmentation && fullBodyCare) ||
                    (burnsAndTurns && enlargedPores && fullBodyCare) ||
                    (tansGradually && enlargedPores && fullBodyCare) ||
                    (notTans && enlargedPores && fullBodyCare) ||
                    (unSure && enlargedPores && fullBodyCare) ||
                    (burnsAndTurns && fineLines && fullBodyCare) ||
                    (tansGradually && fineLines && fullBodyCare) ||
                    (notTans && fineLines && fullBodyCare) ||
                    (unSure && fineLines && fullBodyCare) ||
                    (burnsAndTurns && sensitivity && fullBodyCare) ||
                    (tansGradually && sensitivity && fullBodyCare) ||
                    (notTans && sensitivity && fullBodyCare) ||
                    (unSure && sensitivity && fullBodyCare) ||
                    (burnsAndTurns && unevenSkin && fullBodyCare) ||
                    (tansGradually && unevenSkin && fullBodyCare) ||
                    (notTans && unevenSkin && fullBodyCare) ||
                    (unSure && unevenSkin && fullBodyCare)) &&
                    showResults(productHandles),
                (burnsAndTurns && acne && antiAging) ||
                (tansGradually && acne && antiAging) ||
                (notTans && acne && antiAging) ||
                (unSure && acne && antiAging) ||
                (burnsAndTurns && dryness && antiAging) ||
                (tansGradually && dryness && antiAging) ||
                (notTans && dryness && antiAging) ||
                (unSure && dryness && antiAging) ||
                (burnsAndTurns && oilAndShine && antiAging) ||
                (tansGradually && oilAndShine && antiAging) ||
                (notTans && oilAndShine && antiAging) ||
                (unSure && oilAndShine && antiAging) ||
                (burnsAndTurns && pigmentation && antiAging) ||
                (tansGradually && pigmentation && antiAging) ||
                (notTans && pigmentation && antiAging) ||
                (unSure && pigmentation && antiAging) ||
                (burnsAndTurns && enlargedPores && antiAging) ||
                (tansGradually && enlargedPores && antiAging) ||
                (notTans && enlargedPores && antiAging) ||
                (unSure && enlargedPores && antiAging) ||
                (burnsAndTurns && fineLines && antiAging) ||
                (tansGradually && fineLines && antiAging) ||
                (notTans && fineLines && antiAging) ||
                (unSure && fineLines && antiAging) ||
                (burnsAndTurns && sensitivity && antiAging) ||
                (tansGradually && sensitivity && antiAging) ||
                (notTans && sensitivity && antiAging) ||
                (unSure && sensitivity && antiAging) ||
                (burnsAndTurns && unevenSkin && antiAging) ||
                (tansGradually && unevenSkin && antiAging) ||
                (notTans && unevenSkin && antiAging) ||
                (unSure && unevenSkin && antiAging) ||
                (burnsAndTurns && acne && glowingSkin) ||
                (tansGradually && acne && glowingSkin) ||
                (notTans && acne && glowingSkin) ||
                (unSure && acne && glowingSkin) ||
                (burnsAndTurns && dryness && glowingSkin) ||
                (tansGradually && dryness && glowingSkin) ||
                (notTans && dryness && glowingSkin) ||
                (unSure && dryness && glowingSkin) ||
                (burnsAndTurns && oilAndShine && glowingSkin) ||
                (tansGradually && oilAndShine && glowingSkin) ||
                (notTans && oilAndShine && glowingSkin) ||
                (unSure && oilAndShine && glowingSkin) ||
                (burnsAndTurns && pigmentation && glowingSkin) ||
                (tansGradually && pigmentation && glowingSkin) ||
                (notTans && pigmentation && glowingSkin) ||
                (unSure && pigmentation && glowingSkin) ||
                (burnsAndTurns && enlargedPores && glowingSkin) ||
                (tansGradually && enlargedPores && glowingSkin) ||
                (notTans && enlargedPores && glowingSkin) ||
                (unSure && enlargedPores && glowingSkin) ||
                (burnsAndTurns && fineLines && glowingSkin) ||
                (tansGradually && fineLines && glowingSkin) ||
                (notTans && fineLines && glowingSkin) ||
                (unSure && fineLines && glowingSkin) ||
                (burnsAndTurns && sensitivity && glowingSkin) ||
                (tansGradually && sensitivity && glowingSkin) ||
                (notTans && sensitivity && glowingSkin) ||
                (unSure && sensitivity && glowingSkin) ||
                (burnsAndTurns && unevenSkin && glowingSkin) ||
                (tansGradually && unevenSkin && glowingSkin) ||
                (notTans && unevenSkin && glowingSkin) ||
                (unSure && unevenSkin && glowingSkin) ||
                (burnsAndTurns && acne && darkSpots) ||
                (tansGradually && acne && darkSpots) ||
                (notTans && acne && darkSpots) ||
                (unSure && acne && darkSpots) ||
                (burnsAndTurns && dryness && darkSpots) ||
                (tansGradually && dryness && darkSpots) ||
                (notTans && dryness && darkSpots) ||
                (unSure && dryness && darkSpots) ||
                (burnsAndTurns && oilAndShine && darkSpots) ||
                (tansGradually && oilAndShine && darkSpots) ||
                (notTans && oilAndShine && darkSpots) ||
                (unSure && oilAndShine && darkSpots) ||
                (burnsAndTurns && pigmentation && darkSpots) ||
                (tansGradually && pigmentation && darkSpots) ||
                (notTans && pigmentation && darkSpots) ||
                (unSure && pigmentation && darkSpots) ||
                (burnsAndTurns && enlargedPores && darkSpots) ||
                (tansGradually && enlargedPores && darkSpots) ||
                (notTans && enlargedPores && darkSpots) ||
                (unSure && enlargedPores && darkSpots) ||
                (burnsAndTurns && fineLines && darkSpots) ||
                (tansGradually && fineLines && darkSpots) ||
                (notTans && fineLines && darkSpots) ||
                (unSure && fineLines && darkSpots) ||
                (burnsAndTurns && sensitivity && darkSpots) ||
                (tansGradually && sensitivity && darkSpots) ||
                (notTans && sensitivity && darkSpots) ||
                (unSure && sensitivity && darkSpots) ||
                (burnsAndTurns && unevenSkin && darkSpots) ||
                (tansGradually && unevenSkin && darkSpots) ||
                (notTans && unevenSkin && darkSpots) ||
                (unSure && unevenSkin && darkSpots) ||
                (burnsAndTurns && acne && dullness) ||
                (tansGradually && acne && dullness) ||
                (notTans && acne && dullness) ||
                (unSure && acne && dullness) ||
                (burnsAndTurns && dryness && dullness) ||
                (tansGradually && dryness && dullness) ||
                (notTans && dryness && dullness) ||
                (unSure && dryness && dullness) ||
                (burnsAndTurns && oilAndShine && dullness) ||
                (tansGradually && oilAndShine && dullness) ||
                (notTans && oilAndShine && dullness) ||
                (unSure && oilAndShine && dullness) ||
                (burnsAndTurns && pigmentation && dullness) ||
                (tansGradually && pigmentation && dullness) ||
                (notTans && pigmentation && dullness) ||
                (unSure && pigmentation && dullness) ||
                (burnsAndTurns && enlargedPores && dullness) ||
                (tansGradually && enlargedPores && dullness) ||
                (notTans && enlargedPores && dullness) ||
                (unSure && enlargedPores && dullness) ||
                (burnsAndTurns && fineLines && dullness) ||
                (tansGradually && fineLines && dullness) ||
                (notTans && fineLines && dullness) ||
                (unSure && fineLines && dullness) ||
                (burnsAndTurns && sensitivity && dullness) ||
                (tansGradually && sensitivity && dullness) ||
                (notTans && sensitivity && dullness) ||
                (unSure && sensitivity && dullness) ||
                (burnsAndTurns && unevenSkin && dullness) ||
                (tansGradually && unevenSkin && dullness) ||
                (notTans && unevenSkin && dullness) ||
                (unSure && unevenSkin && dullness) ||
                (Straight && hairDryness) ||
                (Straight && Frizz) ||
                (Straight && Breakage) ||
                (Straight && Dandruff)
                    ? showResults(productHandles)
                    : male && Straight && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : female && Normal && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && Normal && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : (Straight && Irritation) || (Normal && hairDryness) || (Normal && Frizz) || (Normal && Breakage) || (Normal && Dandruff)
                    ? showResults(productHandles)
                    : male && Normal && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : female && Normal && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && Normal && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : (Normal && Irritation) || (Wavy && hairDryness) || (Wavy && Frizz) || (Wavy && Breakage) || (Wavy && Dandruff)
                    ? showResults(productHandles)
                    : male && Wavy && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : female && Wavy && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && Wavy && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : (Wavy && Irritation) || (Coily && hairDryness) || (Coily && Frizz) || (Coily && Breakage) || (Coily && Dandruff)
                    ? showResults(productHandles)
                    : male && Coily && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : female && Coily && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && Coily && CThinning
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : Coily && Irritation
                    ? showResults(productHandles)
                    : female && cellularHealth
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : male && cellularHealth
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : prefer && cellularHealth
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : weightLoss || heart
                    ? showResults(productHandles)
                    : male && nailsGrowth
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : female && nailsGrowth
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && nailsGrowth
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : male && menVitality
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men", "nutraxin-ultra-men-tab-60s"), showResults(productHandles))
                    : female && menVitality
                    ? (productHandles.push("health-max-rascor", "health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && menVitality
                    ? (productHandles.push("health-max-rascor", "health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men", "nutraxin-ultra-men-tab-60s"),
                      showResults(productHandles))
                    : acneFree || womenHealth || birthDefects || boneHealth
                    ? showResults(productHandles)
                    : male && booster
                    ? (productHandles.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : female && booster
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex"), showResults(productHandles))
                    : prefer && booster
                    ? (productHandles.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"), showResults(productHandles))
                    : disorder && showResults(productHandles),
                (quizContainer.innerHTML = ""),
                (quizLoader.classList.remove('t4s-d-none'))
        });
    });
const fetchProductByHandle = (n) =>
        fetch(`${window.Shopify.routes.root}products/${n}.js`)
            .then((n) => n.json())
            .catch((n) => console.error("Error fetching product:", n)),
    fetchProducts = async (n) => {
        const e = [];
        for (const t of n) {
            const n = await fetchProductByHandle(t);
            e.push(n);
        }
        return e;
    },
    renderProducts = (n) => {
        n.forEach((n) => {
            if (n.available) {
                const e = document.createElement("div");
                e.className = "t4s-product t4s-pr-grid t4s-pr-style6 t4s-col-item is-t4s-pr-created";
                const t = document.createElement("div");
                t.className = "t4s-product-wrapper";
                const i = document.createElement("div");
                if (((i.className = "t4s-block-title"), n.tags.length > 0)) {
                    let e = n.tags.filter(
                        (n) =>
                            "Protects" == n ||
                            "Anti-Dandruff" == n ||
                            "Anti-Hair Loss" == n ||
                            "Brightens" == n ||
                            "Cleanse" == n ||
                            "Lightens" == n ||
                            "Multivitamins" == n ||
                            "Rejuvenates" == n ||
                            "Repairs" == n ||
                            "Revitalize" == n ||
                            "Supplements" == n ||
                            "Treats" == n ||
                            "Whitens" == n ||
                            "Weight loss" == n
                    );
                    i.innerText = e[0];
                }
                const a = document.createElement("div");
                (a.className = "t4s-product-inner t4s-pr t4s-oh"),
                    a.setAttribute("data-cacl-slide", ""),
                    a.setAttribute("timeline", ""),
                    a.setAttribute("hdt-reveal", "slide-in"),
                    a.setAttribute("observed", ""),
                    a.setAttribute("animationend", ""),
                    a.style.setProperty("--animation-order", "0");
                const s = document.createElement("div");
                (s.className = "t4s-product-img t4s_ratio is-show-img2"), s.style.setProperty("--aspect-ratioapt", "1");
                const l = document.createElement("img");
                if (
                    (l.setAttribute("data-pr-img", ""),
                    (l.className = "t4s-product-main-img lazyautosizes ls-is-cached lazyloadt4sed"),
                    l.setAttribute("loading", "lazy"),
                    l.setAttribute("data-src", "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),
                    l.setAttribute("data-widths", "[100,200,330,400,500,600,700,800,900]"),
                    l.setAttribute("data-optimumx", "2"),
                    l.setAttribute("data-sizes", "auto"),
                    l.setAttribute("width", `${n.media[0].width}`),
                    l.setAttribute("height", `${n.media[0].height}`),
                    l.setAttribute("alt", `${n.media[0].alt}`),
                    l.setAttribute("src", `${n.images[0]}`),
                    (document.createElement("span").className = "lazyloadt4s-loader"),
                    n.media.length > 1)
                ) {
                    const e = document.createElement("img");
                    e.setAttribute("data-sizes-scale", "1.1"),
                        e.setAttribute("data-pr-img2", ""),
                        (e.className = "t4s-product-hover-img lazyautosizes ls-is-cached lazyloadt4sed"),
                        e.setAttribute("loading", "lazy"),
                        e.setAttribute("data-src", "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),
                        e.setAttribute("data-widths", "[100,200,330,400,500,600,700,800,900,1000]"),
                        e.setAttribute("data-optimumx", "2"),
                        e.setAttribute("data-sizes", "auto"),
                        e.setAttribute("width", `${n.media[1].preview_image.width}`),
                        e.setAttribute("height", `${n.media[1].preview_image.height}`),
                        e.setAttribute("alt", `${n.media[1].alt}`),
                        e.setAttribute("src", `${n.images[1]}`),
                        s.appendChild(e);
                }
                const r = document.createElement("noscript"),
                    u = document.createElement("img");
                (u.className = "t4s-product-main-img"),
                    u.setAttribute("width", `${n.media[0].preview_image.width}`),
                    u.setAttribute("height", `${n.media[0].preview_image.height}`),
                    u.setAttribute("src", `${n.images[0]}`),
                    u.setAttribute("alt", `${n.media[0].alt}`);
                const o = document.createElement("div");
                if (((o.className = "t4s-product-badge"), o.setAttribute("data-product-badge", ""), o.setAttribute("data-sort", "new,soldout,preOrder,custom"), n.compare_at_price > n.price && window.T4Sconfigs.sale_image)) {
                    const n = document.createElement("div");
                    n.className = "t4s-product-badge-sale";
                    const e = document.createElement("span");
                    e.className = "t4s-badge-item";
                    const t = document.createElement("img");
                    (t.src = `${window.T4Sconfigs.sale_image}`),
                        t.setAttribute("width", "336"),
                        t.setAttribute("height", "473"),
                        t.setAttribute("loading", "lazy"),
                        t.setAttribute("width", "336"),
                        t.style.setProperty("width", "50px"),
                        e.appendChild(t),
                        n.appendChild(e),
                        a.appendChild(n);
                }
                const d = document.createElement("div");
                d.className = "t4s-product-btns2";
                const m = document.createElement("a");
                (m.href = `${n.url}`), m.setAttribute("data-tooltip", "left"), m.setAttribute("data-id", `${n.id}`), (m.className = "t4s-pr-item-btn t4s-pr-wishlist t4s-tooltip-actived"), m.setAttribute("data-action-wishlist", "");
                const c = document.createElement("span");
                c.className = "t4s-svg-pr-icon";
                const p = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                p.setAttribute("viewBox", "0 0 24 24");
                const g = document.createElementNS("http://www.w3.org/2000/svg", "use");
                g.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#t4s-icon-wis"), p.appendChild(g), c.appendChild(p);
                const h = document.createElement("span");
                (h.className = "t4s-text-pr"), (h.textContent = "Add to Wishlist"), m.appendChild(c), m.appendChild(h);
                const b = document.createElement("a");
                (b.href = `${n.url}`), b.setAttribute("data-tooltip", "left"), b.setAttribute("data-id", `${n.id}`), (b.className = "t4s-pr-item-btn t4s-pr-quickview t4s-tooltip-actived"), b.setAttribute("data-action-quickview", "");
                const f = document.createElement("span");
                f.className = "t4s-svg-pr-icon";
                const v = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                v.setAttribute("viewBox", "0 0 24 24");
                const y = document.createElementNS("http://www.w3.org/2000/svg", "use");
                y.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#t4s-icon-qv"), v.appendChild(y), f.appendChild(v);
                const A = document.createElement("span");
                (A.className = "t4s-text-pr"), (A.textContent = "Quick view"), b.appendChild(f), b.appendChild(A), d.appendChild(m), d.appendChild(b);
                const S = document.createElement("a");
                S.setAttribute("data-pr-href", ""), (S.className = "t4s-full-width-link is--href-replaced"), (S.href = `${n.url}`);
                const w = document.createElement("div");
                w.className = "t4s-product-info";
                const x = document.createElement("div");
                x.className = "t4s-product-btns";
                const k = document.createElement("div");
                k.className = "t4s-product-atc-qty";
                const B = document.createElement("div");
                (B.className = "t4s-quantity-wrapper t4s-quantity-pr-item"), B.setAttribute("data-quantity-wrapper", "");
                const C = document.createElement("button");
                (C.className = "t4s-quantity-selector is--minus"), (C.type = "button"), C.setAttribute("data-quantity-selector", ""), C.setAttribute("data-decrease-qty", "");
                const T = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                T.setAttribute("class", "icon icon--minus"), T.setAttribute("focusable", "false"), T.setAttribute("viewBox", "0 0 10 2"), T.setAttribute("role", "presentation");
                const H = document.createElementNS("http://www.w3.org/2000/svg", "path");
                H.setAttribute("d", "M10 0v2H0V0z"), H.setAttribute("fill", "currentColor"), T.appendChild(H), C.appendChild(T);
                const E = document.createElement("input");
                (E.type = "number"),
                    (E.className = "t4s-quantity-input"),
                    E.setAttribute("data-quantity-value", ""),
                    E.setAttribute("step", "1"),
                    E.setAttribute("min", "1"),
                    E.setAttribute("name", "quantity"),
                    E.setAttribute("value", "1"),
                    E.setAttribute("size", "4"),
                    E.setAttribute("pattern", "[0-9]*"),
                    E.setAttribute("inputmode", "numeric"),
                    E.setAttribute("data-current-qty", "1");
                const G = document.createElement("button");
                (G.className = "t4s-quantity-selector is--plus"), (G.type = "button"), G.setAttribute("data-quantity-selector", ""), G.setAttribute("data-increase-qty", "");
                const W = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                W.setAttribute("class", "icon icon--plus"), W.setAttribute("focusable", "false"), W.setAttribute("viewBox", "0 0 10 10"), W.setAttribute("role", "presentation");
                const N = document.createElementNS("http://www.w3.org/2000/svg", "path");
                N.setAttribute("d", "M6 4h4v2H6v4H4V6H0V4h4V0h2v4z"), N.setAttribute("fill", "currentColor"), N.setAttribute("fill-rule", "evenodd"), W.appendChild(N), G.appendChild(W), B.appendChild(C), B.appendChild(E), B.appendChild(G);
                const z = document.createElement("a");
                (z.href = "javascript:void(0)"),
                    (z.className = "t4s-pr-item-btn t4s-pr-addtocart t4s-bundle-addtocart"),
                    z.setAttribute("data-variant-id", `${n.variants[0].id}`),
                    (z.textContent = "ADD TO CART"),
                    k.appendChild(B),
                    k.appendChild(z),
                    x.appendChild(k);
                const L = document.createElement("div");
                L.className = "t4s-product-info__inner";
                const P = document.createElement("h3");
                P.className = "t4s-product-title";
                const R = document.createElement("a");
                (R.href = `${n.url}`), (R.className = "is--href-replaced"), (R.textContent = `${n.title}`), P.appendChild(R);
                const q = document.createElement("div");
                if (((q.className = "t4s-product-price"), q.setAttribute("data-pr-price", ""), q.setAttribute("data-product-price", ""), n.compare_at_price > n.price)) {
                    const e = document.createElement("del");
                    e.textContent = `Rs ${(n.compare_at_price / 100).toLocaleString()}`;
                    const t = document.createElement("ins");
                    (t.textContent = `Rs ${(n.price / 100).toLocaleString()}`), q.appendChild(e), q.appendChild(t);
                } else q.textContent = `Rs ${(n.price / 100).toLocaleString()}`;
                L.appendChild(P),
                    L.appendChild(q),
                    w.appendChild(x),
                    w.appendChild(L),
                    r.appendChild(u),
                    s.appendChild(l),
                    a.appendChild(s),
                    a.appendChild(o),
                    a.appendChild(d),
                    a.appendChild(S),
                    t.appendChild(i),
                    t.appendChild(a),
                    t.appendChild(w),
                    e.appendChild(t),
                    quizProducts.appendChild(e);
            }
        });
    };
function showResults(n) {
    dullness && male
        ? n.push("health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men")
        : dullness && female
        ? n.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex")
        : dullness && prefer && n.push("health-max-multivitamin-for-women", "nutraxin-women-multivitamin-complex", "health-max-multivitamin-for-men", "nutraxin-multi-vitamin-for-men"),
        (n = [...new Set(n)]),
        fetchProducts(n).then((e) => {
            let t = ["Cleanse", "Whitens", "Brightens", "Lightens", "Treats", "Repairs", "Rejuvenates", "Revitalize", "Protects", "Anti-Dandruff", "Anti-Hair Loss", "Weight loss", "Multivitamins", "Supplements"];
            e.sort(function (n, e) {
                let i = t.findIndex((e) => n.tags.includes(e)),
                    a = t.findIndex((n) => e.tags.includes(n));
                return -1 === i && (i = t.length), -1 === a && (a = t.length), i - a;
            }),
                renderProducts(e),
                (quizProducts.previousElementSibling.style.display = "block"),
                (quizContainer.previousElementSibling.previousElementSibling.style.display = "block"),
                (quizLoader.classList.add('t4s-d-none')),
                 quizProducts.scrollIntoView({ behavior: "smooth", block: "start" }),
                (n = "");
        });
}